export enum ConsolidatedPaymentReportField
{
  None,
  PaymentType,
  Quantity,
  Received,
  Change,
  Amount
}

export const ConsolidatedPaymentReportFieldLabel = new Map<number, string>([
  [ConsolidatedPaymentReportField.None, 'None'],
  [ConsolidatedPaymentReportField.PaymentType, 'Payment Type'],
  [ConsolidatedPaymentReportField.Quantity, 'Quantity'],
  [ConsolidatedPaymentReportField.Received, 'Received'],
  [ConsolidatedPaymentReportField.Change, 'Change'],
  [ConsolidatedPaymentReportField.Amount, 'Amount']
]);
